import axios from "axios";
import store from "store";
import { getCookie } from "utils/cookie";
import { Message } from "element-ui";
import Vue from "vue";

const protocol = window.location.protocol; // 协议
const currentUrl = window.location.hostname; // 主机名
// const baseURL = protocol + "//" + currentUrl; // 基础URL地址
// const baseURL = "https://kubuqiaward.com"; // 正式版
// const baseURL = "https://pro.kubuqiaward.com"; // 正式环境预览版本
// const baseURL = "http://192.168.1.226:8081"; // 基础URL地址，本地测试用
// const baseURL = "http://47.106.100.200:8012"; // 基础URL地址，本地测试用1

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 60000,
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    let langObj = {
      en: "en-us",
      zhSimple: "zh-cn",
      zhComplex: "zh-hk",
    };
    const lang = localStorage.getItem("lang") || "zhComplex";
    config.headers["think-lang"] = langObj[lang];
    // config.headers["Access-Control-Allow-Origin"] = "*";
    if (getCookie("token")) {
      config.headers["token"] = getCookie("token");
    }
    return config;
  },
  (error) => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response;
    // console.log(res);
    // if the custom code is not 200, it is judged as an error.
    if (res.data.code !== 0) {
      // Vue.prototype.$toast.error(res.message || "Error")
      // 403: forbidden login; 401: Token expired;
      if (res.status === 401 || res.status === 403) {
        store.dispatch("user/resetUserInfo");
      }
      return res.data;
      // return Promise.reject(Message.error(res.data.message || "Error"));
      // return Promise.reject(res.data.message); // 抛出返回的message
    } else {
      return res.data;
    }
  },
  (error) => {
    console.log("err" + error); // for debug
    Message.error(error);
    return Promise.reject(error);
  }
);

export default service;
